import { updateExtension } from "./api";
import { invalidateAllJobExtensionQueries } from "@/modules/work/jobs/extensions/queries";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { formatDateForAPI } from "utils/utils";

function buildPayload(values) {
  const payload = {
    ...values
  }

  if (values.end_date) {
    payload.end_date = formatDateForAPI(values.end_date);
  }

  return payload;
}

export function useUpdateExtension() {
  return useMutation({
    mutationFn: async ({ id, values }) => {
      const payload = buildPayload(values);
      return updateExtension({ id, item: payload });
    },
    onSuccess: () => {
      toast.success("Extension updated successfully");
      invalidateAllJobExtensionQueries();
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
